/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { StyleSheet } from 'react-native';
import { TwTheme } from '@tw/tw-runtime-rn';
import { textWeights } from '@tw/tw-runtime-rn/lib/typescript/theme/base/text';
const theme = TwTheme.values;

export const styles = StyleSheet.create({
  container: {},
  title: {
    ...theme.textSizes.lg,
    fontWeight: theme.textWeights.bold,
    color: theme.textColors.base,
    marginBottom: theme.spaces[2],
    marginTop: theme.spaces[4],
    width: '100%',
    textAlign: 'center'
  },
  formItem: {
    backgroundColor: 'transparent'
  },
  formItemLabel: {
    fontWeight: 'bold',
    color: '#565656',
    fontSize: 14
  },
  fontItemContentWrap: {
    marginTop: 4
  },
  formItemContent: {
    color: '#A4A4A4',
    fontSize: 14
  },
  //command操作区域
  commandContainer: {
    backgroundColor: '#ffffff',
    padding: theme.spaces[4]
  },
  button: {
    borderRadius: 28,
    paddingHorizontal: theme.spaces[3],
    paddingVertical: theme.spaces[2],
    color: theme.primaryColors.base
  },
  beforeAmount: {
    ...theme.textSizes.md, //16
    color: theme.textColors.secondary,
    textDecorationLine: 'line-through'
  },
  amount: {
    ...theme.textSizes['2xl'],
    color: '#F19D4F',
    fontWeight: theme.textWeights.bold,
    marginRight: 10
  },
  label: {
    ...theme.textSizes['md']
  },
  dataItem: {
    ...theme.textSizes['sm'],
    color: theme.textColors.third,
    marginBottom: 4
  },
  priceSymbol: {
    ...theme.textSizes.sm, //16
    color: theme.textColors.secondary
  },
  priceNumber: {
    ...theme.textSizes.md, //16
    color: theme.textColors.secondary,
    textDecorationLine: 'line-through'
  },
  number: {}
});
